import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Header from './components/Header';
import Products from './pages/Products';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Team from './pages/Team';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/products' element={<><Products /><Footer /></>} />
          <Route path='/team' element={<><Team /><Footer /></>} />
          <Route path='/contact' element={<><Contact /><Footer /></>} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
